import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ScrollArea from '@/components/ScrollArea';
import { setFoldersCount, setSearchFolder } from '@/store/myDocuments';

import ListItem from './ListItem';

function List() {
	const dispatch = useDispatch();
	const folders = useSelector(state => state.myDocuments.folders);
	const searchFolder = useSelector(state => state.myDocuments.searchFolder);
	const [folderList, setFolderList] = useState(folders);

	useEffect(() => {
		let newFolderList = folders;
		dispatch(setFoldersCount(newFolderList.length));

		if (!newFolderList.length) {
			dispatch(setSearchFolder(''));
		}

		if (searchFolder) {
			newFolderList = folders.filter(f => f.name.includes(searchFolder));
		}

		setFolderList(newFolderList);
	}, [searchFolder, folders]);

	return (
		<ScrollArea
			autoHide
			className="pb-4"
			orientation="horizontal"
			scrollBarClassName="h-[0.5rem]"
		>
			<ul className="flex gap-5">
				{folderList.map((item, index) => (
					<ListItem key={item.name + index} item={item} />
				))}
			</ul>
		</ScrollArea>
	);
}

export default List;
